const autocompleteLocalization = {
  clearLabel: 'Clear input',
  noResults: 'No items found.',
}

export default autocompleteLocalization
